<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/maintain/config/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('baoyangfenzu')">
            <el-input v-model="yt.conditions.group"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain" :loading="yt.loading">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()" :loading="yt.loading">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary" v-if="utils.checkPower('web_mold_management_maintenance_settings_create')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '模具保养设置-新增' } }">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('daoru', null, 'w2')" style="background-color: #169bd5;color: white;" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '模具保养设置-导入保养分组' } }">
          {{ $t('daorubaoyangfenzumujuguanxi') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <template #baoyangleixing="scope">
        <span v-if="scope.row.type === 0">
          {{ $t('shoucibaoyang') }}
        </span>
        <span v-if="scope.row.type === 1">
          {{ $t('dingqibaoyang') }}
        </span>
        <span v-if="scope.row.type === 2">
          {{ $t('chanqianbaoyang') }}
        </span>
        <span v-if="scope.row.type === 3">
          {{ $t('chanhoubaoyang') }}
        </span>
      </template>
      <template #zhouqileixing="scope">
        <span v-if="scope.row.cycleType === 0">
          {{ $t('hemocishu') }}
        </span>
        <span v-if="scope.row.cycleType === 1">
          {{ $t('antian') }}
        </span>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('muju', scope.row, 'w2')" v-if="utils.checkPower('web_mold_management_maintenance_settings_query_mold')">{{ $t('muju') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('baoyangxiang', scope.row, 'w2')" v-if="utils.checkPower('web_mold_management_maintenance_settings_maintain_items')">{{ $t('baoyangxiang') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)" v-if="utils.checkPower('web_mold_management_maintenance_settings_update')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/maintain/config/delete')" v-if="utils.checkPower('web_mold_management_maintenance_settings_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="'180px'">
          <el-form-item :label="$t('baoyangfenzu')" required>
            <el-input v-model="yt.editObj.group"></el-input>
          </el-form-item>
          <el-form-item :label="$t('baoyangleixing')" required>
            <el-select v-model="yt.editObj.type">
              <el-option :label="$t('shoucibaoyang')" :value="0"></el-option>
              <el-option :label="$t('dingqibaoyang')" :value="1"></el-option>
              <el-option :label="$t('chanqianbaoyang')" :value="2"></el-option>
              <el-option :label="$t('chanhoubaoyang')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zhouqileixing')" required>
            <el-select v-model="yt.editObj.cycleType">
              <el-option :label="$t('hemocishu')" :value="0"></el-option>
              <el-option :label="$t('antian')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zhouqichangdu')" required>
            <yi_number_input type="number" :start.sync="yt.editObj.cycleLength"></yi_number_input>
          </el-form-item>
          <el-form-item :label="$t('baoyanghaoshi(xiaoshi)')" required>
            <yi_number_input :type="number" :start.sync="yt.editObj.timeConsuming"></yi_number_input>
          </el-form-item>
          <el-form-item v-if="yt.editObj.cycleType === 1" :label="$t('baoyangdanshengchengtiqiantianshu')">
            <yi_number_input :type="'number'" :start.sync="yt.editObj.advanceDays" :max="365">
            </yi_number_input>
          </el-form-item>
          <el-form-item v-if="yt.editObj.cycleType === 0" :label="$t('baoyangdanshengchengtiqianmucishu')">
            <yi_number_input :type="'number'" :start.sync="yt.editObj.advanceMouldFrequency" :max="10000">
            </yi_number_input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/maintain/config/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="'180px'">
          <el-form-item class="noborder" :label="$t('baoyangfenzu')" required>
            <el-input disabled v-model="yt.editObj.group"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('baoyangleixing')" required>
            <el-select disabled v-model="yt.editObj.type">
              <el-option :label="$t('shoucibaoyang')" :value="0"></el-option>
              <el-option :label="$t('dingqibaoyang')" :value="1"></el-option>
              <el-option :label="$t('chanqianbaoyang')" :value="2"></el-option>
              <el-option :label="$t('chanhoubaoyang')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('zhouqileixing')" required>
            <el-select disabled v-model="yt.editObj.cycleType">
              <el-option :label="$t('hemocishu')" :value="0"></el-option>
              <el-option :label="$t('antian')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zhouqichangdu')" required>
            <yi_number_input type="number" :start.sync="yt.editObj.cycleLength"></yi_number_input>
          </el-form-item>
          <el-form-item :label="$t('baoyanghaoshi(xiaoshi)')" required>
            <yi_number_input type="number" :start.sync="yt.editObj.timeConsuming"></yi_number_input>
          </el-form-item>
          <el-form-item v-if="yt.editObj.cycleType === 1" :label="$t('baoyangdanshengchengtiqiantianshu')">
            <yi_number_input :type="'number'" :start.sync="yt.editObj.advanceDays" :max="365">
            </yi_number_input>
          </el-form-item>
          <el-form-item v-if="yt.editObj.cycleType === 0" :label="$t('baoyangdanshengchengtiqianmucishu')">
            <yi_number_input :type="'number'" :start.sync="yt.editObj.advanceMouldFrequency" :max="10000">
            </yi_number_input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/maintain/config/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 模具 -->
      <template v-if="yt.editObj.action == 'muju'">
        <div class="dialog-scroller">
          <mold :mold="yt.editObj"></mold>
        </div>
      </template>
      <!-- 保养项 -->
      <template v-if="yt.editObj.action == 'baoyangxiang'">
        <div class="dialog-scroller">
          <item :item="yt.editObj"></item>
        </div>
      </template>

      <template v-if="yt.editObj.action === 'daoru'">
        <div class="dialog-scroller">
          <yi_excel_import ref="mouldMaintainConfigRelationTemplate" :templatekey="'mould_maintain_config_relation_template'" :uploadApi="'/web/maintain/config/batchImport'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :loading="mainSubImportLoading" @click="mainSubImportData">{{ $t('baocun') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import mold from '@@/pages/web/mold_management/maintenance_settings/mold';
import item from '@@/pages/web/mold_management/maintenance_settings/item';
export default {
  name: 'web_mold_management_maintenance_settings_list',
  components: {
    mold,
    item
  },
  data() {
    return {
      list: [],
      mainSubImportLoading: false,
      // organizationList: [],
      columns: [
        {
          label: 'baoyangfenzu',
          prop: 'group',
          width: 130
        },
        {
          label: 'baoyangleixing',
          prop: 'name',
          type: 'slot',
          width: 130
        },
        {
          label: 'zhouqileixing',
          prop: 'orgName',
          type: 'slot'
        },
        {
          label: 'zhouqichangdu',
          prop: 'cycleLength'
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'baoyanghaoshi(xiaoshi)',
          prop: 'timeConsuming',
          width: 150
        },
        {
          label: 'baoyangdanshengchengtiqiantianshu',
          prop: 'advanceDays',
          width: 180
        },
        {
          label: 'baoyangdanshengchengtiqianmucishu',
          prop: 'advanceMouldFrequency',
          width: 180
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 150
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      // this.getOrganizationList();
      this.utils.event_hub.$on('MOLD_SET_MAINTENANCE_REFRESH', () => {
        this.yt.get();
      });
    }, 300);
  },
  methods: {
    // async getOrganizationList() {
    // 	let response = await this.http.get('/web/setting/org/page', {
    // 		params: {
    // 			pageNum: 1,
    // 			pageSize: 1000
    // 		}
    // 	})
    // 	this.organizationList = response.data.rows
    // },
    // 重置
    clear() {
      this.yt.conditions = {
        pageNum: 1,
        pageSize: 10
      };
      this.yt.get(1);
    },

    mainSubImportData() {
      let data = [...this.$refs.mouldMaintainConfigRelationTemplate.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.mouldMaintainConfigRelationTemplate.listLength == null || this.$refs.mouldMaintainConfigRelationTemplate.listLength.length == 0) {
        this.mainSubImportLoading = true;
        return this.http
          .post('/web/maintain/config/batchImport?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.mainSubImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
  }
};
</script>
